import React from "react";
import Link from "next/link";
import Image from "next/image";

import Box from "@/components/shared/Box";

import type { CobasiCuidaProps } from "./cobasiCuida.types";

import s from "./cobasiCuida.module.scss";

const CobasiCuidaBreed = ({ params }: CobasiCuidaProps) => {
  const { especie } = params as { especie: string };
  const isDog = especie === "cachorro" || especie === "cachorros";

  return (
    <Link href="https://www.cobasicuida.com.br/">
      <div className={s.head} data-custom-styles={!isDog}>
        <h2 className="heading-xs">Adote um pet</h2>
        <Image
          className={s.illustration}
          src={`/inst/img/illustration-cobasi-cuida${!isDog ? "-cat" : ""}.svg`}
          alt="Ilustração Cobasi Cuida"
          width={189}
          height={!isDog ? 130 : 109}
        />
      </div>
      <Box
        borderRadius="var(--token-border-radius-lg)"
        border="1px solid var(--token-colors-neutral-cloud-normal)"
        padding="var(--token-spacings-xxs)"
      >
        <div className={s.content}>
          <Image
            src="/inst/img/cobasi-cuida-mundo.svg"
            alt="Logo da Cobasi Cuida"
            width={94}
            height={96}
          />
          <div className={s.description}>
            <p className="body-text-md">
              Desde 1998 promovemos encontros entre pessoas e pets a espera de
              um lar por meio dos nossos eventos de adoção.
            </p>
            <span className="link link-orange">Conheça</span>
          </div>
        </div>
      </Box>
    </Link>
  );
};

export default CobasiCuidaBreed;
